import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import nl from '../assets/lang/nl.json';

Vue.use(VueI18n);

moment.locale('nl');

export default new VueI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: {
    nl,
  },
});
